<sbw-accept-cookies></sbw-accept-cookies>

<div class="header wrapper" [ngClass]="{ 'fixed': !contentLoaded }">
    <header class="row">
        <div class="column small-12">
            <a href="..">
                <img src="/_ng/booking/assets/logo.svg" title="SeaBookWeb" />
            </a>
        </div>
    </header>
</div>
<div *ngIf="content"><sbw-explorer-banner [content]="content"></sbw-explorer-banner></div>
<sbw-loader *ngIf="!contentLoaded" [label]="loadResource"></sbw-loader>
<router-outlet></router-outlet>
<sbw-chat></sbw-chat>